import PropTypes from 'prop-types'
import React from 'react'
import Article from '../templates/Article'

const EME6609PPTElevationPage = props => (
  <Article pathName={props.location.pathname} pageTitle="PowerPoint Elevation">
    <section
      aria-labelledby="section-needs-assessment"
      css={css`
        padding-bottom: 5rem;
      `}
    >
      <div className="contain">
        <h1 id="section-needs-assessment">PowerPoint Elevation</h1>
        <p>
          The PowerPoint Elevation project was intended to enhance our skills
          with PPT as well as education us on some basic concepts that help with
          consistency and design when creating an online or slideshow based
          presentation.
        </p>
        <p>
          I am not totally satisfied with my final PPT presentation. I feel I
          could have done a better job on the title slide especially, where for
          some reason I shifted the color scheme to white where I used black
          throughout the remainder of the presentation. This served as a good
          reminder that no matter how much experience someone has with a topic
          or concept, there's always room for improvement.
        </p>
        <p>
          <a
            href="http://cdn.philsinatra.com/ufl/eme6609/PowerPoint_Elevation.pptx"
            download
          >
            Download PowerPoint Elevation File
          </a>{' '}
          (41mb)
        </p>
      </div>
    </section>
  </Article>
)

EME6609PPTElevationPage.propTypes = {
  location: PropTypes.object,
}

export default EME6609PPTElevationPage
